import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import HotFeed from "./components/HotFeed";
import Sidebar from "./components/Sidebar";
import Features from "./components/Features";
import Channels from "./components/Channels";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import SubscribeContact from "./components/SubscribeContact";
import SiteFooter from "./components/SiteFooter";

function BackTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href="#home"
      aria-label="回到顶部"
      className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </a>
  );
}

export default function Home() {
  return (
    <div className="relative min-h-screen">
      <Navbar />
      <BackTop />

      <main className="mx-auto w-full max-w-7xl px-4 pb-4 pt-24 md:px-6 lg:pt-32">
        {/* intro strip */}
        <div className="mb-5 flex flex-col gap-3 rounded-2xl border border-background-200/70 bg-gradient-to-r from-primary-50 via-background-50 to-accent-50 p-4 md:flex-row md:items-center md:justify-between md:p-5">
          <p className="text-sm leading-relaxed text-foreground-700 md:text-[15px]">
            <span className="mr-2 inline-flex h-5 items-center rounded bg-primary-500 px-1.5 text-[11px] font-bold text-background-50">
              NEW
            </span>
            全网热点滚动更新与即时爆料并行，从最新进展到事件全貌，一手消息持续追踪。
          </p>
          <a
            href="#feature"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            本周深度专题
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* main feed + sidebar */}
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <HotFeed />
          </div>
          <div>
            <Sidebar />
          </div>
        </div>

        {/* deep features */}
        <div className="mt-12">
          <Features />
        </div>

        {/* channels */}
        <div className="mt-12">
          <Channels />
        </div>

        {/* FAQ */}
        <div className="mt-14">
          <FaqSection />
        </div>

        {/* about */}
        <div className="mt-14">
          <AboutSection />
        </div>

        {/* subscribe + contact */}
        <div className="mt-14">
          <SubscribeContact />
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}